import { atom } from 'jotai';
import { quantitativeKpiConfigAtom } from '../../../../../services/state/KPIConfigState';
import {
  financialsKpiDisplayPrefAtom,
  kpiDisplayForCompanyPrefAtom,
} from '../../../../AdminPanel/DataDisplay/DataDisplayState';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';

const resolvedKpiDisplayPrefAtom = atom((get) => {
  const companyId = get(selectedCompanyIdProfileAtom);
  if (companyId > 0) {
    return get(kpiDisplayForCompanyPrefAtom(companyId));
  }
  return get(financialsKpiDisplayPrefAtom);
});

export const financialsDisplayKpisAtom = atom(async (get) => {
  const quantitativeKpis = await get(quantitativeKpiConfigAtom);
  const pref = get(resolvedKpiDisplayPrefAtom);

  if (!quantitativeKpis) {
    return [];
  }
  if (!pref || pref.excludedFields.length === 0) {
    return quantitativeKpis;
  }

  const excludedSet = new Set(pref.excludedFields);
  return quantitativeKpis.filter((kpi) => !excludedSet.has(kpi.entityField));
});

export const financialsFormatterOverridesAtom = atom((get) => {
  const pref = get(resolvedKpiDisplayPrefAtom);
  return pref?.fieldKeyToFormatterId ?? {};
});
